import { render, staticRenderFns } from "./purchaseRecord.vue?vue&type=template&id=2625441c&scoped=true"
import script from "./purchaseRecord.vue?vue&type=script&lang=js"
export * from "./purchaseRecord.vue?vue&type=script&lang=js"
import style0 from "./purchaseRecord.vue?vue&type=style&index=0&id=2625441c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625441c",
  null
  
)

export default component.exports